module.exports = __webpack_public_path__ + "static/media/playagain.5d70857e.png";